module.exports = __webpack_public_path__ + "media/src/images/app_icons/favicons/apple-icon-114x114-0f97e6e376d6870e655225e3ce9c8ef5.png";